<template>
  <div class="recharge">
    <!-- <van-nav-bar :title="title" left-text fixed @click-right="onClickRight">
      <van-icon
        slot="left"
        class="iconfont icon-zuojiantou"
        style="font-size: 0.25rem"
        @click="goBack"
      ></van-icon>
    </van-nav-bar> -->
    <GlobTopNav :title="cardName+'充值'" :rightHidden="false"></GlobTopNav>
    <div class="recharge-bg"></div>

    <div class="van-content">
      <div class="recharge-header">
        <p>{{cardName}}</p>
        <div class="recharge-header-title">
          <span>欢迎使用</span>
          <h3>{{cardName}}充值</h3>
        </div>
      </div>

      <div class="recharge-content" v-if="this.step == 1">
        <div class="recharge-war">
          <div class="recharge-input">
            <div class="codebox">
              <img src="./../../../assets/img/card.svg" alt="" />
              <div class="van-cell__value">
                <input
                  type="text"
                  placeholder="请输入卡号"
                  v-model="cardNum"
                  class="van-field__control"
                />
              </div>
            </div>
            <div class="codebox">
              <img src="./../../../assets/img/code.svg" alt="" />
              <div class="van-cell__value">
                <input
                  type="text"
                  placeholder="请输入验证码"
                  v-model="code"
                  class="van-field__control"
                />
              </div>
              <div class="van-field__button">
                <div class="code" @click="refreshCode">
                  <s-identify :identifyCode="identifyCode"></s-identify>
                </div>
              </div>
            </div>
          </div>
          <van-button class="skype" @click="next()">立即充值</van-button>
        </div>
        <ul class="tishi">
          <li class="tishi-title">温馨提示：</li>
          <li>1.我司发行的{{cardName}}为12/16位数字+字母的组合，均为{{ unit }}卡。</li>
          <li>2.{{cardName}}的卡密只能输入大写字母。</li>
          <li>3.{{cardName}}充值后将立即到账。</li>
        </ul>
      </div>

      <div v-if="step == 2" class="pointsucceed">
        <div class="title">
          <img src="./../../../assets/img/success.svg" alt="" />
          <h3>充值成功</h3>
          <p>您已成功充值{{ getnum }}{{ unit }}</p>
        </div>
        <div class="pay-btns">
          <van-button class="pay" @click="godetail()">查看{{ unit }}记录</van-button>
          <van-button class="pay pay-view" @click="goHome()">返回首页</van-button>
        </div>
      </div>
    </div>

    <Nvc 
      ref="nverify" 
      :verify="verifyMethods"
    ></Nvc>
  </div>
</template>

<script>
import Nvc from "../../login/components/nvc";
import SIdentify from "../../../components/identify";
export default {
  name: "password",
  components: {
    SIdentify,
    Nvc
  },
  computed: {
    unit: function() {
      return this.$store.state.unitinfo.name;
    },
    cardName: function() {
      return this.$store.state.webCount.card_name;
    }
  },
  data() {
    return {
      cardNum: "",
      code: "",
      identifyCodes: "1234567890", //图片验证码
      identifyCode: "", //图片验证码
      step: 1,
      title: "",
      getnum: 0
    };
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    godetail: function() {
      this.$router.push({ path: "/user/mymoney" });
    },
    goHome: function() {
      this.$router.push({ path: "/" });
    },
    onClickRight() {
      console.log("按钮");
    },
    next: function() {
      // var reg = /^[0-9A-Z]{16}$/
      if (this.cardNum == "") {
        this.$dialog
          .alert({
            title: "提示",
            message: "请输入正确的卡面编号！"
          })
          .then(() => {
            // on close
          });
      } else if (this.code == "") {
        this.$dialog
          .alert({
            title: "提示",
            message: "验证码不能为空！"
          })
          .then(() => {
            // on close
          });
      } else if (this.code != this.identifyCode) {
        this.$toast("验证码错误！");
        this.refreshCode();
      } else {
        // this.sendData()
        this.$refs.nverify.startVerify()
      }
    },
    sendData: function(captchaVerifyParam) {
      return new Promise((resolve, reject) => {
        var isUser = localStorage.getItem("BLHuser");
        var mallid = localStorage.getItem("mallid");
        this.$api.post(
          "user/card/recharge",
          {
            id_example: mallid,
            token_user: isUser,
            code: this.cardNum,
            captchaVerifyParam
          },
          res => {
            this.errpr = res.data;
            if (res.data.code == "100") {
              //            this.$router.push({ path: '/pointsucceed' })
              this.step = 2;
              this.title = "充值成功";
              this.getnum = res.data.data;
              resolve(true)
            } else if (
              res.data.code == "400"
            ) {
              resolve(false)
              _this.codeLoading = false;
            } else if (res.data.code == "800") {
              this.$toast("登录次数过多请稍后再试");
              _this.codeLoading = false;
            } else {
              if (res.data.message == "token验证失败") {
                this.$dialog
                  .confirm({
                    title: "提示 ",
                    message: "您还未登录是否去登录？"
                  })
                  .then(() => {
                    this.$router.push({ name: "NoteLogin" });
                  })
                  .catch(() => {});
              } else {
                this.$toast(res.data.message);
              }
              resolve(true)
            }
          }
        );
      })
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    verifyMethods(captchaVerifyParam) {
      return new Promise(async(resolve, reject) => {
        const data = await this.sendData(captchaVerifyParam)
        console.log(data)
        resolve(data)
      })
    }
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    var unit = localStorage.getItem("unit");
    var unitname = unit + "卡充值";
    this.title = unitname;
  }
};
</script>

<style lang="less">
.recharge {
  width: 100%;
  min-height: 100vh;
  background-color: rgba(245, 245, 245, 1);
  position: relative;

  .recharge-bg {
    width: 100%;
    height: 3.3rem;
    background: linear-gradient(133deg, #ffffff 0%, #f3e1d0 100%);
    position: absolute;
    top: 0;
  }

  .van-content {
    position: relative;
    z-index: 1;
    margin-top: 0.6rem;
    background-color: rgba(245, 245, 245, 0);

    .recharge-header {
      width: calc(100% - 0.6rem);
      height: 3.28rem;
      background: #e23130;
      box-shadow: 0rem 0.16rem 0.22rem 0rem rgba(231, 75, 58, 0.36);
      border-radius: 0.16rem;
      margin: 0 auto;
      background-image: url("./../../../assets/img/recharge-bg.png");
      background-size: 100%;
      background-repeat: no-repeat;
      box-sizing: border-box;
      padding: 0.3rem;

      p {
        width: 100%;
        text-align: right;
        font-size: 0.26rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }

      .recharge-header-title {
        margin-top: 0.72rem;
        span {
          font-size: 0.24rem;
          font-weight: 600;
          color: #ffffff;
          line-height: 0.34rem;
        }

        h3 {
          font-size: 0.52rem;
          font-weight: 600;
          color: #ffffff;
          line-height: 0.74rem;
        }
      }
    }

    .recharge-content {
      .recharge-war {
        width: calc(100% - 0.6rem);
        margin: 0.6rem auto 0 auto;
        background: #ffffff;
        border-radius: 0.24rem;
        box-sizing: border-box;
        padding: 0 0.4rem 0.4rem 0.4rem;

        .recharge-input {
          .codebox {
            width: 100%;
            height: 1.58rem;
            display: flex;
            align-items: center;
            border-bottom: 0.01rem solid #eee;

            img {
              width: 0.44rem;
              height: 0.48rem;
            }

            .van-cell__value {
              padding-left: 0.2rem;
            }

            .van-field__button {
              .code {
                /*margin: 4rem auto;*/
                width: 2.5rem;
                height: 0.7rem;

                #s-canvas {
                  width: 100% !important;
                  height: 100% !important;
                }
              }
            }
          }
        }

        .skype {
          margin-top: 0.56rem;
          width: 100%;
          height: 0.96rem;
          background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
          border-radius: 0.48rem;
          font-size: 0.3rem;
          font-weight: 400;
          color: #ffffff;
          line-height: 0.42rem;
        }
      }

      .tishi {
        width: 100%;
        box-sizing: border-box;
        padding: 0 0.3rem;
        margin-top: 0.3rem;

        li {
          font-size: 0.24rem;
          font-weight: 400;
          color: #929292;
          line-height: 0.42rem;
        }
      }
    }
  }

  .pointsucceed {
    width: calc(100% - 0.6rem);
    margin: 0.6rem auto 0 auto;
    background: #ffffff;
    border-radius: 0.24rem;
    box-sizing: border-box;
    padding: 0.4rem 0.4rem 0.4rem 0.4rem;

    .title {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 0.88rem;
        height: 0.88rem;
      }

      h3 {
        font-size: 0.36rem;
        font-weight: 500;
        color: #262626;
        line-height: 0.5rem;
        margin-top: 0.1rem;
      }

      p {
        font-size: 0.28rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 0.5);
        line-height: 0.48rem;
      }
    }

    .pay-btns {
      display: flex;
      justify-content: space-between;
      margin-top: 0.68rem;

      .pay {
        width: 2.9rem;
        height: 0.96rem;
        background: #fdf5f5;
        border-radius: 0.5rem;
        border: 0.02rem solid #e23331;
        font-size: 0.3rem;
        font-weight: 400;
        color: #e23331;
        line-height: 0.96rem;
      }

      .pay-view {
        background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/recharge/index.vue